import * as classnames from 'classnames'
import * as React from 'react'

import EnhancedLazyLoad from '../../../components/enhancedLazyLoad'
import ImagePlaceholder from '../../../components/imagePlaceholder'
import SafeInnerHtml from '../../../components/safeInnerHtml'

import * as styles from './tutorialPost.module.css'

interface IProps {
  imgSrc: string
  title: string
  link: string
  description: string
  hideOnMobile?: boolean
}

const TutorialPost = ({
  imgSrc,
  title,
  link,
  description,
  hideOnMobile
}: IProps) => {
  const rootClassNames = classnames(styles.root, {
    [styles.hideOnMobile]: hideOnMobile
  })
  return (
    <article className={rootClassNames}>
      <header>
        <a href={link} aria-label={title}>
          <EnhancedLazyLoad placeholder={<ImagePlaceholder />}>
            <img alt={title} src={imgSrc} className={styles.img} />
          </EnhancedLazyLoad>
        </a>
        <a href={link} className={styles.title}>
          {title}
        </a>
      </header>
      <section className={styles.description}>
        <SafeInnerHtml html={description} />
      </section>
    </article>
  )
}

export default TutorialPost
